// extracted by mini-css-extract-plugin
export default {"popconfirm":"Popconfirm_popconfirm__DNK6A","popconfirmFooter":"Popconfirm_popconfirmFooter__nWC2D"};